import { Box } from "@mui/material"
import React, { useContext, useEffect, useState } from "react"
import { UserTypeContext } from "../context/userStatus";
import moment from "moment";

const AccountRestrictionTimeout = ({ showFullTime = false }) => {
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const { userDetails = {} } = IUserTypeState
    console.log("IUserTypeState userDetails", userDetails);
    const [timing, setTiming] = useState("")

    useEffect(() => {
        if (userDetails?.userAccountStatus) {
            const setTime = () => {
                // Target time (UTC)
                const targetTime = moment.utc(userDetails?.userAccountStatus);

                // Get current time (UTC)
                const now = moment.utc();

                // Calculate the difference
                const duration = moment.duration(targetTime.diff(now));

                // Extract days, hours, minutes, seconds
                const countdown = {
                    days: duration.days(),
                    hours: duration.hours(),
                    minutes: duration.minutes(),
                };
                if (showFullTime) {
                    setTiming(`${countdown.days} days, ${countdown.hours} hours, ${countdown.minutes} minutes`)
                } else {
                    setTiming(`${countdown.days}D:${countdown.hours}H:${countdown.minutes}M`)
                }
            }
            setTime()
            let timer = setInterval(setTime, 10000);
            return () => clearInterval(timer)
        }
    }, [showFullTime, userDetails])
    return <>{timing}</>
}

export default React.memo(AccountRestrictionTimeout)